export function getSubDomain(location: Location) {
    return location.hostname.replace(/\..+$/, "");
}

export function getUuid() {
    return "test"; // TODO: get from meta tag?
}
